import { map } from 'lodash'
import { TimezoneData } from '../apis/timezone.api'

export default {
  selectOptions (timezones: TimezoneData[]) {
    return map(timezones, timezone => {
      const { name, id } = timezone
      return { name, value: String(id) }
    })
  }
}
